import { VUE_APP_BASEURL } from "../../utils/api";
import axios from "axios";
import store from "..";
// import samplebanner from "../../assets/sample.png";
const state = {
    brandList: [],
    brand: [],
    brandBanners: [''],
    // brandBanners: [samplebanner],
    brandProducts: [],
    brandAddonProducts: [],
    brandstatusload: "",
    brandpage: false,
    brandslug: "",
    brandaddon: true,
}
const getters = {
    brandLists: state => state.brandList,
    brandDetails: state => state.brand,
    brandBannersDetails: state => state.brandBanners,
    brandStatus: state => state.brandstatusload,
    brandProductList: state => state.brandProducts,
    brandAddonProductList: state => state.brandAddonProducts,
    BrandPage: state => state.brandpage,
    BrandSlug: state => state.brandslug,
    BrandAddOn: state => state.brandaddon,
}
const actions = {
    async getBrandList({ commit }) {
        //console.log(categoryId);
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "brand/" + store.getters.UserLocation,
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                //    console.log(response.data);
                if (response.data.status == 1) {
                    //    console.log(response.data.response.category);
                    commit("updateBrandList", response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    async getBrandDetails({ commit }, branddetail) {
        //console.log(categoryId);
        if(branddetail.brandstore == true)
        {
            commit('BRANDPAGE', true);
            commit('BRANDADDON', false);
            commit('BRANDSLUG', branddetail.brandslug);
        } else {
            commit('BRANDPAGE', false);
            commit('BRANDADDON', true);
            commit('BRANDSLUG', '');
        }
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "brand/details/" + branddetail.brandslug +"?orderkey="+ store.getters.getCartToken,
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                // console.log(response.data);
                if (response.data.status == 1) {
                    //    console.log(response.data.response.category);
                    commit("updateBrandDetails", response.data);
                    if(store.getters.BrandPage == true)
                    {
                        commit('BRANDADDON', response.data.response.brand.addon);
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    async getBrandProduct({ commit }, searchData) {
        // console.log(categoryData.subCategoryId);
        if(searchData.brandstore == true)
        {
            commit('BRANDPAGE', true);
            commit('BRANDADDON', false);
            commit('BRANDSLUG', searchData.brandslug);
        } else {
            commit('BRANDPAGE', false);
            commit('BRANDADDON', true);
            commit('BRANDSLUG', '');
        }
        commit("authBrandRequest");
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "brand/product/" + searchData.brandslug + "/" + store.getters.UserLocation + "?orderkey=" + store.getters.getCartToken + "&search=" + searchData.search,
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                //  console.log(response);
                if (response.data.status == 1) {
                    commit("listBrandProduct", response.data);
                    commit("authBrandSuccess");
                }
            })
            .catch(function (error) {
                //   commit("authError");
                console.log(error);
            });
    },
    async getBrandAddonProduct({ commit }, searchData) {
        // console.log(categoryData.subCategoryId);
        if(searchData.brandstore == true)
        {
            commit('BRANDPAGE', true);
            commit('BRANDADDON', false);
            commit('BRANDSLUG', searchData.brandslug);
        } else {
            commit('BRANDPAGE', false);
            commit('BRANDADDON', true);
            commit('BRANDSLUG', '');
        }
        commit("authBrandRequest");
        axios({
            method: "GET",
            url: VUE_APP_BASEURL + "brand/product/addon/" + searchData.brandslug + "/" + store.getters.UserLocation + "?orderkey=" + store.getters.getCartToken + "&search=" + searchData.search,
            headers: {
                Authorization: "Bearer " + store.getters.getUserToken
            },
        })
            .then(function (response) {
                //console.log(response);
                if (response.data.status == 1) {
                    commit("listBrandAddonProduct", response.data);
                    commit("authBrandSuccess");
                }
            })
            .catch(function (error) {
                console.log(error);
                // commit("authError");
            });
    },
}

const mutations = {
    authBrandRequest: state => {
        state.brandstatusload = "loading";
    },
    authBrandError: (state) => {
        state.brandstatusload = "error";
    },
    authBrandSuccess: (state) => {
        state.brandstatusload = "success";
    },
    updateBrandList: (state, resp) => {
        state.brandList = resp.response.brand;
    },
    updateBrandDetails: (state, resp) => {
        state.brand = resp.response.brand;
        state.brandBanners = resp.response.brand.banner;
    },
    listBrandProduct: (state, resp) => {
        state.brandProducts = resp.response.product;
    },
    listBrandAddonProduct: (state, resp) => {
        state.brandAddonProducts = resp.response.product;
    },
    BRANDPAGE: (state, resp) => {
        state.brandpage = resp;
    },
    BRANDSLUG: (state, resp) => {
        state.brandslug = resp;
    },
    BRANDADDON: (state, resp) => {
        state.brandaddon = resp;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
};